import { DeepPartial, InstallHVACPackage } from 'types';

import { api } from './api';

export const installPackageApi = api.injectEndpoints({
  endpoints: (build) => ({
    saveInstallHVACPackage: build.mutation<any, { accountId: string; savePackage: DeepPartial<InstallHVACPackage> }>(
      {
        query: ({ accountId, savePackage }) => ({
          url: `v2/accounts/${accountId}/install-package/hvac/save`,
          method: 'POST',
          body: { ...savePackage },
        }),
        invalidatesTags: (_result, _error, arg) => [
          { type: 'Accounts', id: arg?.accountId },
          { type: 'SystemDesign', id: arg?.accountId },
        ],
      },
    ),
    submitInstallHVACPackage: build.mutation<any, { accountId: string; installPackage: InstallHVACPackage }>({
      query: ({ accountId, installPackage }) => ({
        url: `v2/accounts/${accountId}/install-package/hvac/submit`,
        method: 'POST',
        body: { ...installPackage },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'Queues', accountId: arg?.accountId },
        { type: 'SystemDesign', id: arg?.accountId },
        { type: 'AccountMilestones', id: arg?.accountId },
      ],
    }),
  }),
});

export const { useSaveInstallHVACPackageMutation, useSubmitInstallHVACPackageMutation } = installPackageApi;
